// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
[data-v-774c9996] {
	box-sizing: border-box;
}
.set-select[data-v-774c9996] {
	display: inline-block;
	position: relative;
	--invertedness: 100%;
	vertical-align: middle;
	width: 16em;
	user-select: none;
}
.select[data-v-774c9996] {
	position: relative;
	border-radius: 4px;
	border: 1px solid #888;
	height: 28px;
	width: 16em;
	min-height: auto;
	padding: 0;
	padding-right: 20px;
	background-color: #555;
	cursor: pointer;
}
.expanded .select[data-v-774c9996] {
	border-radius: 4px 4px 0 0;
}
.select[data-v-774c9996]::after {
	position: absolute;
	right: 5px;
	top: 50%;
	transform: translateY(-50%);
	color: #999;
	font-family: "Mini Font Awesome 5 Free";
	font-weight: 900;
	content: "\\f0d7";
	transition: transform 0.12s ease-in-out;
}
.expanded .select[data-v-774c9996]::after {
	transform: translateY(-50%) rotate(180deg);
}
.selected-sets[data-v-774c9996] {
	display: inline-flex;
	align-items: center;
	gap: 4px;
	border-radius: 4px;
	height: 28px;
	min-height: auto;
	padding: 4px 5px;
	max-width: 100%;
	font-size: 14px;
	overflow-x: hidden;
	white-space: nowrap;
}
.selected-set-name[data-v-774c9996] {
	text-overflow: ellipsis;
	overflow-x: hidden;
	white-space: nowrap;
}
.options[data-v-774c9996] {
	position: absolute;
	top: 100%;
	left: 0;
	right: 0;
	z-index: 10;

	display: flex;
	flex-direction: column;
	max-height: 0;
	overflow-y: auto;

	background-color: #555;
	border-radius: 0 0 10px 10px;
	border: 1px solid #888;
	border-top: 0;
	border-bottom: 0;

	filter: drop-shadow(2px 4px 2px rgba(0, 0, 0, 0.5));

	padding: 0;
	transition: max-height 0.14s ease-in-out;
}
.expanded .options[data-v-774c9996] {
	max-height: min(400px, 60vh);
}
.option[data-v-774c9996] {
	position: relative;
	padding: 5px;
	padding-left: 0;

	cursor: pointer;

	transition: all 100ms ease-in-out;
}
.option[data-v-774c9996]:hover {
	background-color: #41b883;
}
.multiselect-selected.option[data-v-774c9996] {
	background: #eee;
	color: #222;
	--invertedness: 0%;
}
.option[data-v-774c9996]::before {
	position: absolute;
	bottom: 0;
	left: 0;
	width: 100%;
	max-width: 0;
	height: 2px;
	background-color: #41b883;
	transition: max-width 250ms ease-in-out;
	z-index: 1;
	content: "";
}
.multiselect-selected.option[data-v-774c9996]:hover::before {
	max-width: 100%;
}
.option.long-press[data-v-774c9996]::before {
	transition: max-width 500ms linear;
	max-width: 100%;
	background-color: white;
}
.multiselect-selected.option.long-press[data-v-774c9996]::before {
	background-color: #ff6a6a;
	max-width: 0;
}
.multiselect-selected.option.ctrl[data-v-774c9996]:hover {
	background: #ff6a6a;
}
.option.ctrl[data-v-774c9996]:not(.multiselect-selected):hover::after,
.multiselect-selected.option[data-v-774c9996]::after {
	position: absolute;
	top: 50%;
	right: 16px;
	transform: translateY(-50%) translateX(50%);
	line-height: 20px;
	font-size: 10px;
	padding-left: inherit;
	font-family: "Mini Font Awesome 5 Free";
	font-weight: 900;
}
.multiselect-selected.option[data-v-774c9996]::after {
	content: "\\f00c";
}
.option.ctrl[data-v-774c9996]:not(.multiselect-selected):hover::after {
	content: "+";
	font-size: 1.35em;
}
.multiselect-selected.option.ctrl[data-v-774c9996]:hover::after {
	content: "\\f00d";
}
.multiselect-selected.option.long-press[data-v-774c9996]:hover::after {
	content: "\\f00d";
}
.placeholder[data-v-774c9996] {
	color: #adadad;
}
.set-option[data-v-774c9996] {
	display: flex;
	align-items: center;
}
.set-option-name[data-v-774c9996] {
	display: inline-block;
	max-width: 14em;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
	font-size: 14px;
	padding: 5px;
	padding-left: 0;
}
`, "",{"version":3,"sources":["webpack://./client/src/components/SetSelect.vue"],"names":[],"mappings":";AAmIA;CACC,sBAAsB;AACvB;AAEA;CACC,qBAAqB;CACrB,kBAAkB;CAClB,oBAAoB;CACpB,sBAAsB;CACtB,WAAW;CACX,iBAAiB;AAClB;AAEA;CACC,kBAAkB;CAClB,kBAAkB;CAClB,sBAAsB;CACtB,YAAY;CACZ,WAAW;CACX,gBAAgB;CAChB,UAAU;CACV,mBAAmB;CACnB,sBAAsB;CACtB,eAAe;AAChB;AAEA;CACC,0BAA0B;AAC3B;AAEA;CACC,kBAAkB;CAClB,UAAU;CACV,QAAQ;CACR,2BAA2B;CAC3B,WAAW;CACX,uCAAuC;CACvC,gBAAgB;CAChB,gBAAgB;CAChB,uCAAuC;AACxC;AAEA;CACC,0CAA0C;AAC3C;AAEA;CACC,oBAAoB;CACpB,mBAAmB;CACnB,QAAQ;CACR,kBAAkB;CAClB,YAAY;CACZ,gBAAgB;CAChB,gBAAgB;CAChB,eAAe;CACf,eAAe;CACf,kBAAkB;CAClB,mBAAmB;AACpB;AAEA;CACC,uBAAuB;CACvB,kBAAkB;CAClB,mBAAmB;AACpB;AAEA;CACC,kBAAkB;CAClB,SAAS;CACT,OAAO;CACP,QAAQ;CACR,WAAW;;CAEX,aAAa;CACb,sBAAsB;CACtB,aAAa;CACb,gBAAgB;;CAEhB,sBAAsB;CACtB,4BAA4B;CAC5B,sBAAsB;CACtB,aAAa;CACb,gBAAgB;;CAEhB,mDAAmD;;CAEnD,UAAU;CACV,wCAAwC;AACzC;AAEA;CACC,4BAA4B;AAC7B;AAEA;CACC,kBAAkB;CAClB,YAAY;CACZ,eAAe;;CAEf,eAAe;;CAEf,iCAAiC;AAClC;AAEA;CACC,yBAAyB;AAC1B;AAEA;CACC,gBAAgB;CAChB,WAAW;CACX,kBAAkB;AACnB;AAEA;CACC,kBAAkB;CAClB,SAAS;CACT,OAAO;CACP,WAAW;CACX,YAAY;CACZ,WAAW;CACX,yBAAyB;CACzB,uCAAuC;CACvC,UAAU;CACV,WAAW;AACZ;AAEA;CACC,eAAe;AAChB;AAEA;CACC,kCAAkC;CAClC,eAAe;CACf,uBAAuB;AACxB;AAEA;CACC,yBAAyB;CACzB,YAAY;AACb;AAEA;CACC,mBAAmB;AACpB;AACA;;CAEC,kBAAkB;CAClB,QAAQ;CACR,WAAW;CACX,2CAA2C;CAC3C,iBAAiB;CACjB,eAAe;CACf,qBAAqB;CACrB,uCAAuC;CACvC,gBAAgB;AACjB;AAEA;CACC,gBAAgB;AACjB;AAEA;CACC,YAAY;CACZ,iBAAiB;AAClB;AAEA;CACC,gBAAgB;AACjB;AAEA;CACC,gBAAgB;AACjB;AAEA;CACC,cAAc;AACf;AAEA;CACC,aAAa;CACb,mBAAmB;AACpB;AAEA;CACC,qBAAqB;CACrB,eAAe;CACf,gBAAgB;CAChB,uBAAuB;CACvB,mBAAmB;CACnB,eAAe;CACf,YAAY;CACZ,eAAe;AAChB","sourcesContent":["<template>\n\t<div class=\"set-select\" :class=\"{ expanded: expanded }\" @pointerdown.stop>\n\t\t<div class=\"select\" @click.stop=\"toggle\">\n\t\t\t<slot name=\"selection\" :values=\"modelValue\">\n\t\t\t\t<span class=\"selected-sets\" v-if=\"modelValue.length == 1\" :key=\"modelValue[0]\">\n\t\t\t\t\t<img\n\t\t\t\t\t\tclass=\"set-icon\"\n\t\t\t\t\t\tstyle=\"padding-left: 4px; padding-right: 4px\"\n\t\t\t\t\t\t:src=\"SetsInfos[modelValue[0]].icon\"\n\t\t\t\t\t\t:alt=\"SetsInfos[modelValue[0]].code\"\n\t\t\t\t\t/>\n\t\t\t\t\t<span class=\"selected-set-name\">{{ SetsInfos[modelValue[0]].fullName }}</span>\n\t\t\t\t</span>\n\t\t\t\t<span class=\"selected-sets multiple\" v-else-if=\"modelValue.length > 1\" key=\"multiple\">\n\t\t\t\t\t<span>({{ modelValue.length }})</span>\n\t\t\t\t\t<TransitionGroup name=\"fade\">\n\t\t\t\t\t\t<img v-for=\"v in modelValue\" class=\"set-icon\" :src=\"SetsInfos[v].icon\" :key=\"v\" />\n\t\t\t\t\t</TransitionGroup>\n\t\t\t\t</span>\n\t\t\t\t<span class=\"selected-sets placeholder\" v-else key=\"placeholder\">All Cards</span>\n\t\t\t</slot>\n\t\t</div>\n\t\t<div class=\"options\">\n\t\t\t<slot name=\"beforeList\"></slot>\n\t\t\t<div\n\t\t\t\tv-for=\"option in options\"\n\t\t\t\t:key=\"option\"\n\t\t\t\t@pointerup.exact.stop=\"pointerup(option)\"\n\t\t\t\t@pointerup.ctrl.exact.stop=\"ctrlpointerup(option)\"\n\t\t\t\t@pointerdown=\"pointerdown($event, option)\"\n\t\t\t\t@pointerout=\"pointerout(option)\"\n\t\t\t\tclass=\"option\"\n\t\t\t\t:class=\"{\n\t\t\t\t\t'multiselect-selected': modelValue.includes(option),\n\t\t\t\t\tctrl: ctrlPressed,\n\t\t\t\t\t'long-press': longPressingSet === option,\n\t\t\t\t}\"\n\t\t\t>\n\t\t\t\t<slot name=\"option\" :option=\"option\">\n\t\t\t\t\t<span class=\"set-option\">\n\t\t\t\t\t\t<img\n\t\t\t\t\t\t\tclass=\"set-icon padded-icon\"\n\t\t\t\t\t\t\t:src=\"SetsInfos[option].icon\"\n\t\t\t\t\t\t\t:alt=\"SetsInfos[option].code\"\n\t\t\t\t\t\t\theight=\"16\"\n\t\t\t\t\t\t\twidth=\"48\"\n\t\t\t\t\t\t/>\n\t\t\t\t\t\t<span class=\"set-option-name\">\n\t\t\t\t\t\t\t{{ SetsInfos[option].fullName }}\n\t\t\t\t\t\t</span>\n\t\t\t\t\t</span>\n\t\t\t\t</slot>\n\t\t\t</div>\n\t\t\t<slot name=\"afterList\"></slot>\n\t\t</div>\n\t</div>\n</template>\n\n<script setup lang=\"ts\">\nimport { SetCode } from \"@/Types\";\nimport SetsInfos from \"../../../src/SetInfos\";\nimport { ref, onMounted, onUnmounted } from \"vue\";\n\nconst props = defineProps<{\n\tmodelValue: SetCode[];\n\toptions: SetCode[];\n}>();\n\nconst expanded = ref(false);\nconst ctrlPressed = ref(false);\nconst longPressTimeout = ref(null as ReturnType<typeof setTimeout> | null);\nconst longPressingSet = ref(null as SetCode | null);\n\nconst clearLongPress = () => {\n\tif (longPressTimeout.value) clearTimeout(longPressTimeout.value);\n\tlongPressingSet.value = null;\n};\n\nconst emit = defineEmits<{\n\t(e: \"update:modelValue\", value: SetCode[]): void;\n}>();\n\nconst add = (c: SetCode) => {\n\tif (!props.modelValue.includes(c)) emit(\"update:modelValue\", [...props.modelValue, c]);\n\telse\n\t\temit(\n\t\t\t\"update:modelValue\",\n\t\t\tprops.modelValue.filter((v) => v !== c)\n\t\t);\n};\nconst set = (c: SetCode) => emit(\"update:modelValue\", [c]);\nconst toggle = () => (expanded.value = !expanded.value);\nconst close = () => (expanded.value = false);\nconst checkctrl = (e: KeyboardEvent) => (ctrlPressed.value = e.ctrlKey);\n\nconst pointerdown = (e: PointerEvent, c: SetCode) => {\n\tclearLongPress();\n\tlongPressTimeout.value = setTimeout(() => {\n\t\tadd(c);\n\t\tclearLongPress();\n\t}, 500);\n\tlongPressingSet.value = c;\n\te.preventDefault();\n\te.stopPropagation();\n};\nconst pointerup = (c: SetCode) => {\n\tif (c === longPressingSet.value) set(c);\n\tclearLongPress();\n};\nconst ctrlpointerup = (c: SetCode) => {\n\tif (c === longPressingSet.value) add(c);\n\tclearLongPress();\n};\nconst pointerout = (c: SetCode) => {\n\tif (c === longPressingSet.value) clearLongPress();\n};\n\nonMounted(() => {\n\tdocument.addEventListener(\"keydown\", checkctrl);\n\tdocument.addEventListener(\"keyup\", checkctrl);\n\tdocument.addEventListener(\"pointerdown\", close);\n});\n\nonUnmounted(() => {\n\tdocument.removeEventListener(\"keydown\", checkctrl);\n\tdocument.removeEventListener(\"keyup\", checkctrl);\n\tdocument.removeEventListener(\"pointerdown\", close);\n});\n</script>\n\n<style scoped>\n* {\n\tbox-sizing: border-box;\n}\n\n.set-select {\n\tdisplay: inline-block;\n\tposition: relative;\n\t--invertedness: 100%;\n\tvertical-align: middle;\n\twidth: 16em;\n\tuser-select: none;\n}\n\n.select {\n\tposition: relative;\n\tborder-radius: 4px;\n\tborder: 1px solid #888;\n\theight: 28px;\n\twidth: 16em;\n\tmin-height: auto;\n\tpadding: 0;\n\tpadding-right: 20px;\n\tbackground-color: #555;\n\tcursor: pointer;\n}\n\n.expanded .select {\n\tborder-radius: 4px 4px 0 0;\n}\n\n.select::after {\n\tposition: absolute;\n\tright: 5px;\n\ttop: 50%;\n\ttransform: translateY(-50%);\n\tcolor: #999;\n\tfont-family: \"Mini Font Awesome 5 Free\";\n\tfont-weight: 900;\n\tcontent: \"\\f0d7\";\n\ttransition: transform 0.12s ease-in-out;\n}\n\n.expanded .select::after {\n\ttransform: translateY(-50%) rotate(180deg);\n}\n\n.selected-sets {\n\tdisplay: inline-flex;\n\talign-items: center;\n\tgap: 4px;\n\tborder-radius: 4px;\n\theight: 28px;\n\tmin-height: auto;\n\tpadding: 4px 5px;\n\tmax-width: 100%;\n\tfont-size: 14px;\n\toverflow-x: hidden;\n\twhite-space: nowrap;\n}\n\n.selected-set-name {\n\ttext-overflow: ellipsis;\n\toverflow-x: hidden;\n\twhite-space: nowrap;\n}\n\n.options {\n\tposition: absolute;\n\ttop: 100%;\n\tleft: 0;\n\tright: 0;\n\tz-index: 10;\n\n\tdisplay: flex;\n\tflex-direction: column;\n\tmax-height: 0;\n\toverflow-y: auto;\n\n\tbackground-color: #555;\n\tborder-radius: 0 0 10px 10px;\n\tborder: 1px solid #888;\n\tborder-top: 0;\n\tborder-bottom: 0;\n\n\tfilter: drop-shadow(2px 4px 2px rgba(0, 0, 0, 0.5));\n\n\tpadding: 0;\n\ttransition: max-height 0.14s ease-in-out;\n}\n\n.expanded .options {\n\tmax-height: min(400px, 60vh);\n}\n\n.option {\n\tposition: relative;\n\tpadding: 5px;\n\tpadding-left: 0;\n\n\tcursor: pointer;\n\n\ttransition: all 100ms ease-in-out;\n}\n\n.option:hover {\n\tbackground-color: #41b883;\n}\n\n.multiselect-selected.option {\n\tbackground: #eee;\n\tcolor: #222;\n\t--invertedness: 0%;\n}\n\n.option::before {\n\tposition: absolute;\n\tbottom: 0;\n\tleft: 0;\n\twidth: 100%;\n\tmax-width: 0;\n\theight: 2px;\n\tbackground-color: #41b883;\n\ttransition: max-width 250ms ease-in-out;\n\tz-index: 1;\n\tcontent: \"\";\n}\n\n.multiselect-selected.option:hover::before {\n\tmax-width: 100%;\n}\n\n.option.long-press::before {\n\ttransition: max-width 500ms linear;\n\tmax-width: 100%;\n\tbackground-color: white;\n}\n\n.multiselect-selected.option.long-press::before {\n\tbackground-color: #ff6a6a;\n\tmax-width: 0;\n}\n\n.multiselect-selected.option.ctrl:hover {\n\tbackground: #ff6a6a;\n}\n.option.ctrl:not(.multiselect-selected):hover::after,\n.multiselect-selected.option::after {\n\tposition: absolute;\n\ttop: 50%;\n\tright: 16px;\n\ttransform: translateY(-50%) translateX(50%);\n\tline-height: 20px;\n\tfont-size: 10px;\n\tpadding-left: inherit;\n\tfont-family: \"Mini Font Awesome 5 Free\";\n\tfont-weight: 900;\n}\n\n.multiselect-selected.option::after {\n\tcontent: \"\\f00c\";\n}\n\n.option.ctrl:not(.multiselect-selected):hover::after {\n\tcontent: \"+\";\n\tfont-size: 1.35em;\n}\n\n.multiselect-selected.option.ctrl:hover::after {\n\tcontent: \"\\f00d\";\n}\n\n.multiselect-selected.option.long-press:hover::after {\n\tcontent: \"\\f00d\";\n}\n\n.placeholder {\n\tcolor: #adadad;\n}\n\n.set-option {\n\tdisplay: flex;\n\talign-items: center;\n}\n\n.set-option-name {\n\tdisplay: inline-block;\n\tmax-width: 14em;\n\toverflow: hidden;\n\ttext-overflow: ellipsis;\n\twhite-space: nowrap;\n\tfont-size: 14px;\n\tpadding: 5px;\n\tpadding-left: 0;\n}\n</style>\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
